import React from "react";

const TransportAbout = () => {
  const brandCyan = "#0ea5e9";
  const brandPurple = "#d946ef";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Hero / Header Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                display: "block",
                textTransform: "uppercase",
              }}
            >
              ✦ SEAMLESS MOBILITY & LOGISTICS
            </span>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Reliable Transportation Solutions for{" "}
              <span style={{ color: brandPurple }}>Passengers & Freight</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandCyan }}>Iconic Transport</strong> is
              a premier mobility provider dedicated to offering safe, punctual,
              and high-comfort transportation services across long-distance,
              intercity, and corporate routes.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "28px",
              }}
            >
              Combining a modern fleet equipped with GPS tracking with highly
              trained professional drivers, we ensure smooth journeys and
              hassle-free logistics tailored to both personal and corporate
              travel requirements.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {[
                "100% On-Time Express Routes",
                "GPS Tracked Modern Fleet",
                "24/7 Passenger Support",
                "Certified Professional Drivers",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandPurple,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <img
              src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1200&q=85"
              alt="Iconic Transport Fleet"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                1M+
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Safe Miles Covered
              </span>
            </div>
          </div>
        </div>

        {/* ================= 2. Stats Bar ================= */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            padding: "32px 24px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "500,000+", label: "Happy Passengers" },
            { value: "120+", label: "Modern Buses & Vans" },
            { value: "50+", label: "Connected Routes" },
            { value: "99.4%", label: "Punctuality Rate" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. Core Services Grid ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              WHAT WE OFFER
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Comprehensive Transportation{" "}
              <span style={{ color: brandCyan }}>Services</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "24px",
            }}
          >
            {[
              {
                title: "Intercity Express Travel",
                desc: "Scheduled, high-comfort luxury coach services operating daily across major transport hubs.",
              },
              {
                title: "Corporate Fleet Rental",
                desc: "Custom employee shuttle programs and executive transport solutions for corporate clients.",
              },
              {
                title: "Private Charter Buses",
                desc: "Dedicated buses for group travel, family tours, educational trips, and corporate events.",
              },
              {
                title: "Express Cargo & Parcel",
                desc: "Fast, reliable same-day and next-day parcel delivery using our scheduled transport network.",
              },
              {
                title: "Airport Transfers",
                desc: "Punctual airport pick-up and drop-off services designed for hassle-free connections.",
              },
              {
                title: "VIP Luxury Transport",
                desc: "Premium vehicles with recliner seating, onboard Wi-Fi, and personalized cabin hospitality.",
              },
            ].map((service, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "26px 22px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.6",
                  }}
                >
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 4. Commitment / Safety Highlights ================= */}
        <div
          style={{
            background: "#fdf4ff",
            border: "1px solid #f5d0fe",
            padding: "40px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "30px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              OUR CORE COMMITMENT
            </span>
            <h3
              style={{
                fontSize: "26px",
                fontWeight: "800",
                color: "#0f172a",
                margin: "8px 0 12px 0",
              }}
            >
              Passenger Comfort & Uncompromised Safety
            </h3>
            <p
              style={{
                fontSize: "15px",
                color: "#475569",
                lineHeight: "1.65",
                margin: 0,
              }}
            >
              Every vehicle in our fleet undergoes rigorous preventative
              maintenance checkups. With real-time vehicle telemetry, speed
              limiting systems, and dual-driver rotations on long routes, we
              prioritize passenger safety above all else.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            {[
              {
                title: "Air-Conditioned",
                desc: "Climate control in every vehicle",
              },
              {
                title: "GPS Monitored",
                desc: "Live route tracking for safety",
              },
              { title: "Reclining Seats", desc: "Ergonomic seating comfort" },
              {
                title: "Onboard Wi-Fi",
                desc: "Stay connected throughout travel",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "18px 16px",
                  borderRadius: "10px",
                  border: "1px solid #fae8ff",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 4px 0",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: brandPurple,
                  }}
                >
                  {item.title}
                </h4>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    lineHeight: "1.4",
                    display: "block",
                  }}
                >
                  {item.desc}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Bottom CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #d946ef 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#fff",
              }}
            >
              Book Your Next Journey Today
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Experience effortless travel, route flexibility, and supreme
              comfort with Iconic Transport.
            </p>
          </div>

          <div style={{ display: "flex", gap: "14px" }}>
            <button
              style={{
                background: "#ffffff",
                color: "#0f172a",
                border: "none",
                padding: "14px 26px",
                borderRadius: "8px",
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}
            >
              Reserve Ticket →
            </button>
          </div>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default TransportAbout;
